import $ from 'jquery';

$( window ).resize(function() {
});

$(window).scroll(function () {

});

$(document).ready(function () {
  //Give container to wp-block-columns dashboard elements
  var wpBlockColumns = $('.wp-block-columns');
  if (wpBlockColumns.length > 0) {
    wpBlockColumns.addClass('container wp-columns-customs');
  }

  // // /********* STICKY MENU **********/
  var stickyNavTop = 25;
  var stickyNav = function () {
    var scrollTop = $(window).scrollTop();
    var ht = $('#header').outerHeight();
    if (scrollTop > stickyNavTop) {
      $('#header').addClass('is_stuck');
    } else {
      $('#header').removeClass('is_stuck');
    }
  };
  stickyNav();
  $(window).scroll(function () {
    stickyNav();
  });
  /* *************************************** */

  var elemIntro = $('.home-full-wrapper .intro-wrapper');
  var elemQualities = $('.home-full-wrapper .qualities-wrapper');
  if (elemIntro.length > 0 && elemQualities.length > 0) {
    var padt   = parseInt(elemIntro.css('padding-top'));
    var height = (elemQualities.outerHeight() != 0)? elemQualities.outerHeight()/2 : 0;
    elemIntro.css('padding-top',(padt + height)+"px");
  }

  $("#footer-email-input").keyup(function(e) {
    var val = ($(this).val());
    var custarget = $('#footer-email-link').data('custarget');
    $('#footer-email-link').attr('href',custarget + val);
  });

});
